// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerRow":"Footer_footerRow__6HEl7","link":"Footer_link__sgKeT","rsslogo":"Footer_rsslogo__vecwu"};